<ion-card>
    <ion-row>
        <ion-col size="3">
            <img [src]="donation.urls" alt="User Avatar" />
        </ion-col>
        <ion-col size="9" class="padding5 ">
            <div class="font1_2 bold">{{ donation.purpose }}</div>
            <div class="font0_9">{{ donation.remarks }}</div>
            <div class="mediumColor font0_9" *ngIf="donation.target_amount"> Target:{{ donation.target_amount |
                twoDigit}}</div>
            <div class="mediumColor font0_9 textRight">
                <span class="floatLeft">{{ donation.created_at | fancyDate }}</span>
                <span class="margin5px">{{ donation.created_by?.user?.name }}</span>
                <img class="circular" *ngIf="donation.created_by?.user?.url" [src]="donation.created_by.user.url"
                    width="20px" height="auto" />
            </div>
        </ion-col>
    </ion-row>
    <div class="font1_2 bold">Account Details</div>
    <ion-row *ngIf="donation.json_details">
        <ion-col size="9">
            <ion-row>
                <ion-col size="4" class="borderMedium" *ngIf="donation.json_details.acc_name">Name:</ion-col>
                <ion-col size="8" class="borderMedium" *ngIf="donation.json_details.acc_name">{{
                    donation.json_details.acc_name }}</ion-col>

                <ion-col size="4" class="borderMedium" *ngIf="donation.json_details.acc_bank">Bank Name:</ion-col>
                <ion-col size="8" class="borderMedium" *ngIf="donation.json_details.acc_bank">{{
                    donation.json_details.acc_bank }}</ion-col>

                <ion-col size="4" class="borderMedium" *ngIf="donation.json_details.acc_mobile">Mobile:</ion-col>
                <ion-col size="8" class="borderMedium" *ngIf="donation.json_details.acc_mobile">{{
                    donation.json_details.acc_mobile }}</ion-col>

                <ion-col size="4" class="borderMedium" *ngIf="donation.json_details.acc_mobile2">Alt. Mob:</ion-col>
                <ion-col size="8" class="borderMedium" *ngIf="donation.json_details.acc_mobile2">{{
                    donation.json_details.acc_mobile2 }}</ion-col>

                <ion-col size="4" class="borderMedium" *ngIf="donation.json_details.acc_number">Acc No.:</ion-col>
                <ion-col size="8" class="borderMedium" *ngIf="donation.json_details.acc_number">{{
                    donation.json_details.acc_number }}</ion-col>

                <ion-col size="4" class="borderMedium" *ngIf="donation.json_details.acc_ifsc">IFSC:</ion-col>
                <ion-col size="8" class="borderMedium" *ngIf="donation.json_details.acc_ifsc">{{
                    donation.json_details.acc_ifsc }}</ion-col>

                <ion-col size="4" class="borderMedium" *ngIf="donation.json_details.acc_branch">Branch:</ion-col>
                <ion-col size="8" class="borderMedium" *ngIf="donation.json_details.acc_branch">{{
                    donation.json_details.acc_branch }}</ion-col>

                <ion-col size="4" class="borderMedium" *ngIf="donation.json_details.acc_upi">UPI Id:</ion-col>
                <ion-col size="8" class="borderMedium" *ngIf="donation.json_details.acc_upi">{{
                    donation.json_details.acc_upi }}</ion-col>
            </ion-row>
        </ion-col>
        <ion-col size="3">
            <a href="{{donation.json_details.qrUrl}}" target="_blank">
                <img src="{{donation.json_details.qrUrl}}">
            </a>
        </ion-col>
    </ion-row>

    <ion-row *ngIf="donation.json_details" class="textCenter bold padding5">
        <ion-col size="4">
            Committed <br>
            <ion-badge color="medium" mode="ios">{{acs.committedTotal | twoDigit}}</ion-badge><br>
            <ion-badge color="medium" mode="ios">{{acs.committedTotal2 | twoDigit}}</ion-badge>
        </ion-col>
        <ion-col size="4">
            Received <br>
            <ion-badge color="success" mode="ios">{{acs.receivedTotal | twoDigit}}</ion-badge><br>
            <ion-badge color="success" mode="ios">{{acs.receivedTotal2 | twoDigit}}</ion-badge>
        </ion-col>
        <ion-col size="4" *ngIf="acs.deniedTotal>0">
            Denied <br>
            <ion-badge color="danger" mode="ios">{{acs.deniedTotal | twoDigit}}</ion-badge><br>
            <ion-badge color="danger" mode="ios">{{acs.deniedTotal2 | twoDigit}}</ion-badge>
        </ion-col>
    </ion-row>
</ion-card>